import { MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { timestampToDate } from "../../shared/utils/date";
import { convertChartLabelDate, dateFormatKey, dateFormatRich } from "../converters";
import { generateDefaultMetrics } from "../generators";
import { type InsightsMetricsMap, type StatsItem } from "../models";

export const mapInsightsMetrics = (
    responseEntryList: readonly MyLensesOrganicStatsResponseEntry[],
    metricsFields: MetricField[],
    containsIncompleteDate?: boolean,
    containsPreviousPeriod = true,
): { metrics: InsightsMetricsMap<StatsItem>; metricsPrevious: InsightsMetricsMap<StatsItem> } => {
    const metrics = generateDefaultMetrics(metricsFields);
    const metricsPrevious = generateDefaultMetrics(metricsFields);

    const [responseEntry] = responseEntryList;

    if (!responseEntry) {
        return { metrics, metricsPrevious };
    }

    const entries = responseEntry.statsResponseTimeEntryList;
    const entriesMedian = containsPreviousPeriod ? Math.floor(entries.length / 2) : 0;

    entries.forEach(({ statsList: stats, timestamp }, index) => {
        stats.forEach(({ field, statsList }) => {
            let value = Number.parseFloat(statsList[0]?.value ?? "");

            if (!field) {
                return;
            }
            const previousMetric = metricsPrevious[field.fieldName];
            const metric = metrics[field.fieldName];

            if (field.fieldName === MetricField.LensLongPlayRatio) {
                value *= 100;
            }

            if (index < entriesMedian) {
                if (previousMetric) {
                    previousMetric.totalValue += value;
                }
            } else {
                const date = timestampToDate(timestamp);

                if (metric) {
                    metric.stats = [
                        ...metric.stats,
                        {
                            value,
                            key: convertChartLabelDate(date, dateFormatKey),
                            date: `${convertChartLabelDate(date, dateFormatRich)} UTC`,
                            isDateIncomplete: containsIncompleteDate && index === entries.length - 1,
                        },
                    ];

                    metric.totalValue += value;
                }
            }
        });
    });

    return { metrics, metricsPrevious };
};
